import { SvgIcon, SvgIconProps } from '@mui/material';

export function WomanWithFormInTablet(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 1500 1500'
    >
      <path
        d='M1194.73 557.934C929.525 498.732 918.247 70.5919 590.393 138.771C298.493 199.473 427.436 375.151 155.263 656.229C-116.909 937.307 212.779 1340.71 430.978 1258.27C649.178 1175.82 876.823 1375 1081.22 1295.88C1567.76 1107.54 1472.94 647.717 1194.73 557.934Z'
        fill='#D6E4FF'
      />
      <rect
        x='298.701'
        y='396.064'
        width='543.735'
        height='959.638'
        fill='#755E01'
      />
      <rect
        x='310.812'
        y='407.668'
        width='515.295'
        height='948.034'
        fill='#D8EFFE'
      />
      <path
        d='M480.972 408.11C482.101 454.355 476.648 475.505 423.188 478.896C473.086 503.352 469.998 520.934 436.189 555.822C432.383 602.356 419.453 610.705 375.515 591.576C382.982 618.454 395.367 680.273 349.553 685.263C361.8 721.098 334.759 767.074 310.543 754.211L310.543 408.11H480.972Z'
        fill='#48B92B'
      />
      <path
        d='M706.004 880.665C688.154 873.028 668.813 866.702 650.06 861.55C642.694 852.558 645.857 857.845 641.881 856.082C635.645 853.326 629.951 848.581 626.878 854.727C618.066 844.83 613.457 830.641 610.52 817.898C609.932 815.458 610.384 812.249 609.164 809.719C615.807 803.483 627.194 785.949 632.346 777.68C634.967 773.477 643.372 751.244 644.637 750.386C647.258 748.533 653.133 750.657 654.85 749.708C667.006 743.201 674.824 725.532 671.886 712.201C668.633 697.379 654.669 704.474 651.416 702.666C648.569 701.084 637.859 662.583 633.702 654.947C626.562 641.797 613.096 630.951 603.018 620.151C588.377 646.496 564.201 667.509 534.828 676.095C527.553 678.219 507.173 678.58 503.467 680.207C500.259 681.608 498.361 697.334 495.966 700C493.887 702.305 479.065 694.668 474.14 709.535C469.214 724.402 481.144 741.845 493.932 749.753C496.418 751.289 503.693 750.476 505.546 751.786C506.63 752.555 512.505 771.896 515.081 776.324C518.244 781.792 535.19 801.946 535.551 803.618C535.913 805.29 528.592 830.957 527.372 834.979C525.926 839.769 518.47 850.479 517.837 853.371C512.098 847.271 511.917 851.79 504.19 854.727C502.609 855.314 504.687 848.129 496.011 860.195C483.584 859.336 452.178 877.999 442.824 876.553C432.837 875.017 420.907 857.393 418.286 848.581C403.419 798.919 450.37 746.138 464.65 699.91C488.193 623.631 458.188 585.582 558.101 565.563C618.157 553.543 649.653 570.262 670.621 627.607C680.743 655.218 677.083 682.15 682.912 710.8C694.119 766.157 733.163 823.953 706.094 880.62L706.004 880.665Z'
        fill='#714227'
      />
      <path
        d='M583.949 599.681C596.059 621.371 546.035 671.486 529.406 669.226C521.226 668.142 542.104 660.279 543.053 659.692C565.737 645.096 579.249 626.568 583.994 599.681H583.949Z'
        fill='black'
      />
      <path
        d='M680.789 752.465C691.001 774.562 695.34 801.811 693.08 826.123L680.789 752.465Z'
        fill='black'
      />
      <path
        d='M564.834 1077.1C591.224 1074.25 586.028 1110.49 560.722 1101.64C546.306 1096.62 550.916 1078.59 564.834 1077.1Z'
        fill='#15285C'
      />
      <path
        d='M710.117 1188.94C709.439 1195.54 710.433 1201.55 711.472 1208.06C627.195 1242.67 521.679 1234.63 435.955 1208.06C437.627 1200.19 438.486 1192.02 440.067 1184.88C440.067 1184.74 478.512 1171.72 479.099 1171.54C480.946 1185.41 484.327 1200.1 487.264 1201.05C495.986 1203.8 449.615 1201.28 474.818 1201.28L653.737 1198.76L656.459 1171.54C669.744 1173.57 694.978 1185.92 710.117 1189.03V1188.94Z'
        fill='#0A3789'
      />
      <path
        d='M711.472 1208.01C718.07 1249.68 728.508 1298.3 731.943 1339.65C732.169 1342.4 733.886 1354.29 731.265 1355.33H420.229C421.992 1306.93 425.788 1255.37 435.91 1208.01C521.679 1234.58 627.15 1242.63 711.427 1208.01H711.472Z'
        fill='#0D1632'
      />
      <path
        d='M463.882 1285.78L564.156 1345.12C562.033 1348.32 560.541 1346.61 558.011 1345.79C545.358 1341.68 476.716 1301.69 466.639 1292.61C465.057 1291.16 460.132 1288.09 463.927 1285.78H463.882Z'
        fill='black'
      />
      <path
        d='M706.004 880.666C723.628 888.213 755.757 900.956 763.304 919.528C766.331 926.985 765.563 937.107 767.416 942.71C783.548 992.283 801.579 1041.72 812.424 1092.74C811.204 1094.18 809.939 1095.18 808.312 1096.13C807.86 1096.4 806.143 1095.86 805.601 1096.13C818.299 1083.16 786.712 1097.62 778.984 1098.84C769.63 1100.37 749.747 1098.39 743.511 1100.19C740.212 1101.14 743.014 1103.9 742.833 1104.31C742.698 1104.67 745.454 1108.06 740.122 1109.77C721.956 1041.13 732.259 1027.8 741.478 963.136C741.929 960.018 745.725 936.519 742.155 936.519C733.976 964.763 731.536 994.497 725.119 1023.15C717.482 1057.17 702.751 1089.8 703.293 1126.13C699.859 1126.49 685.308 1131.92 683.5 1131.6C682.28 1131.37 673.875 1121.16 670.531 1119.31L663.707 1109.77C663.979 1088.22 666.438 1071.29 669.175 1045.65C665.379 1032.14 613.502 1039.82 602.341 1036.79C608.938 1022.38 666.012 935.796 665.108 927.662C664.837 925.041 648.117 915.19 645.993 911.304L671.932 897.657C672.7 895.669 652.952 864.985 650.106 861.506C668.859 866.657 688.2 872.984 706.049 880.621L706.004 880.666Z'
        fill='#2848A4'
      />
      <path
        d='M504.145 854.728L480.963 893.59L510.969 916.772L487.109 932.453C484.352 934.441 485.753 934.667 486.431 937.243C487.922 942.846 543.053 1032.18 547.798 1035.44C553.989 1039.69 563.343 1036.57 570.302 1037.47L572.335 1034.08C559.547 995.988 548.34 957.352 536.862 918.806L607.809 916.094L575.092 1036.79C575.679 1037.61 593.167 1038.06 594.885 1037.47C599.358 1035.98 639.757 966.977 644.683 957.668C646.671 953.917 660.092 929.289 659.686 927.663C659.324 926.262 639.622 914.106 637.859 909.949L666.509 894.946L641.971 856.083C645.948 857.846 642.785 852.513 650.151 861.551C652.998 865.031 672.745 895.714 671.977 897.702L646.038 911.349C648.117 915.236 664.837 925.087 665.153 927.708C666.057 935.842 608.984 1022.42 602.386 1036.84C613.548 1039.91 665.425 1032.18 669.22 1045.7L453.714 1047.05C454.121 1044.43 456.787 1038.65 461.216 1037.52C470.073 1035.21 542.285 1040.77 543.731 1035.48L480.963 935.887C480.602 928.34 501.569 922.059 505.501 915.416L475.495 894.946C482.861 884.281 488.555 870.453 495.966 860.15C504.642 848.13 502.564 855.315 504.145 854.682V854.728Z'
        fill='black'
      />
      <path
        d='M641.881 856.127L666.419 894.989L637.769 909.992C639.531 914.149 659.234 926.305 659.595 927.706C660.002 929.333 646.581 953.961 644.593 957.711C639.667 967.02 599.268 1036.02 594.794 1037.51C593.077 1038.1 575.589 1037.65 575.002 1036.84L607.718 916.138V912.025C613.367 909.404 620.01 879.218 622.721 871.084C623.896 867.559 625.975 856.353 626.833 854.726C629.906 848.58 635.6 853.325 641.836 856.081L641.881 856.127Z'
        fill='#2848A4'
      />
      <path
        d='M517.792 853.371C516.527 858.884 519.193 864.397 520.504 869.729C524.209 885.003 532.479 899.96 536.862 914.737C537.043 915.28 535.868 915.551 536.862 918.849C548.34 957.35 559.547 995.987 572.335 1034.13L570.302 1037.52C563.343 1036.57 553.989 1039.73 547.798 1035.48C543.008 1032.18 487.922 942.845 486.431 937.287C485.753 934.756 484.352 934.485 487.109 932.496L510.969 916.816L480.963 893.634L504.145 854.772C511.872 851.834 512.053 847.315 517.792 853.416V853.371Z'
        fill='#15285C'
      />
      <path
        d='M495.966 860.194C488.555 870.497 482.861 884.325 475.495 894.99L505.501 915.46C501.569 922.058 480.557 928.384 480.963 935.931L543.731 1035.53C542.285 1040.81 470.073 1035.26 461.216 1037.56C456.787 1038.74 454.121 1044.52 453.714 1047.1C455.058 1062.67 456.017 1075.28 457.78 1085.35C459.813 1096.92 461.216 1101.68 463.249 1118.04C457.013 1120.03 452.539 1121.12 446.891 1124.87L418.919 1000.73L415.53 1004.12L433.244 1076.42L425.065 1111.9C423.347 1113.52 422.173 1111.22 419.597 1111.22C412.547 1111.22 343.182 1099.7 339.115 1097.57C338.889 1097.44 337.534 1094.27 335.003 1094.18C348.063 1032.77 371.335 973.438 388.19 912.749C398.539 893.95 427.912 890.878 442.733 876.598C452.133 878.044 483.539 859.381 495.921 860.24L495.966 860.194Z'
        fill='#2848A4'
      />
      <path
        d='M446.846 1124.82C446.078 1125.32 442.959 1127.4 442.734 1127.53C435.549 1125.41 425.607 1124.5 418.874 1122.06C417.654 1121.61 418.332 1119.4 418.196 1119.35C417.97 1119.26 419.145 1117.73 416.84 1116.64L419.552 1111.17C422.127 1111.17 423.302 1113.48 425.019 1111.85L433.199 1076.38L415.485 1004.08L418.874 1000.69L446.846 1124.82Z'
        fill='black'
      />
      <path
        d='M392.98 909.315L395.692 1019.8C392.031 1019.62 391.58 1013.84 390.902 1010.95C388.642 1001.27 382.768 909.315 392.935 909.315H392.98Z'
        fill='black'
      />
      <path
        d='M740.122 1109.82C740.935 1112.89 741.974 1115.15 742.833 1118C743.059 1118.67 742.743 1119.85 742.833 1120.71C733.253 1121.34 715.268 1124.91 703.293 1126.18C702.75 1089.84 717.482 1057.22 725.119 1023.19C731.536 994.586 734.021 964.807 742.155 936.563C745.725 936.563 741.929 960.062 741.477 963.18C732.259 1027.8 721.956 1041.18 740.122 1109.82Z'
        fill='black'
      />
      <path
        d='M805.601 1096.17C788.158 1104.44 761.903 1104.17 742.833 1104.35C743.014 1103.94 740.212 1101.23 743.511 1100.24C749.747 1098.43 769.63 1100.37 778.984 1098.88C786.712 1097.62 818.299 1083.2 805.601 1096.17Z'
        fill='#F5F4F5'
      />
      <path
        d='M622.812 871.131C620.1 879.265 613.457 909.451 607.809 912.072C593.845 918.489 553.401 912.524 536.862 914.784C532.479 900.007 524.209 885.049 520.504 869.775C534.241 873.662 547.617 881.796 562.123 883.422C583.045 885.772 605.007 882.88 622.812 871.131Z'
        fill='#DDDDDD'
      />
      <path
        d='M609.164 809.719C590.185 827.523 575.679 830.28 552.543 817.898C551.142 817.175 536.184 802.308 536.862 807.685C558.779 835.386 585.214 855.721 610.52 817.898C613.502 830.641 618.067 844.831 626.878 854.727C626.065 856.399 623.986 867.561 622.766 871.086C604.962 882.835 583 885.727 562.077 883.377C547.572 881.75 534.196 873.616 520.458 869.73C519.148 864.398 516.482 858.839 517.747 853.371C518.425 850.479 525.836 839.77 527.282 834.98C528.502 830.958 535.823 805.2 535.461 803.618C535.1 801.946 518.154 781.792 514.991 776.324C512.415 771.851 506.495 752.555 505.456 751.787C503.648 750.476 496.328 751.29 493.842 749.753C481.054 741.8 468.943 724.944 474.049 709.535C479.156 694.126 493.797 702.305 495.876 700C498.271 697.334 500.169 681.608 503.377 680.207C507.128 678.581 527.463 678.219 534.738 676.095C564.111 667.555 588.287 646.497 602.928 620.151C613.051 630.952 626.472 641.752 633.612 654.947C637.769 662.629 648.524 701.085 651.326 702.666C654.579 704.474 668.543 697.424 671.796 712.201C674.734 725.532 666.916 743.201 654.76 749.708C652.998 750.657 647.168 748.578 644.547 750.386C643.327 751.244 634.877 773.477 632.256 777.68C627.104 785.995 615.717 803.483 609.074 809.719H609.164Z'
        fill='#FCA397'
      />
      <path
        d='M609.164 809.72C610.384 812.296 609.977 815.459 610.52 817.899C585.214 855.722 558.778 835.387 536.862 807.686C536.184 802.309 551.187 817.176 552.542 817.899C575.634 830.236 590.185 827.524 609.164 809.72Z'
        fill='#845549'
      />
      <path
        d='M480.285 714.236C493.842 716.993 493.164 730.369 499.4 741.53C487.922 733.17 493.797 718.529 478.93 716.993L480.285 714.282V714.236Z'
        fill='#4C2B20'
      />
      <path
        d='M664.43 714.236C666.328 714.326 666.689 715.004 667.819 716.269C654.76 717.399 662.261 723.047 660.996 725.804C658.555 731.181 651.777 735.52 650.783 742.84C647.123 735.429 655.889 730.413 658.284 725.804C658.872 724.629 654.579 713.739 664.43 714.19V714.236Z'
        fill='#4C2B20'
      />
      <path
        d='M607.809 912.025V916.138L536.862 918.849C535.868 915.55 537.043 915.324 536.862 914.737C553.401 912.477 593.8 918.442 607.809 912.025Z'
        fill='black'
      />
      <path
        d='M662.352 1115.29C665.063 1116.46 667.91 1117.95 670.531 1119.4C673.875 1121.25 682.28 1131.46 683.5 1131.69C685.308 1132.05 699.859 1126.58 703.293 1126.22C715.268 1125 733.253 1121.39 742.833 1120.75C766.603 1119.17 798.325 1121.75 813.78 1142.58C824.219 1156.68 821.869 1180.68 811.069 1193.74C791.547 1217.28 736.1 1194.32 710.117 1188.94C695.023 1185.83 682.506 1185.51 669.175 1183.48C645.767 1179.91 651.235 1177.02 634.38 1168.47C626.698 1164.59 607.628 1161.29 606.408 1152.12L650.06 1166.44C639.034 1156.09 619.422 1156 607.764 1150.76C601.889 1148.09 586.344 1137.75 599.584 1133.05L650.06 1150.08C637.046 1138.42 613.231 1139.06 599.584 1131.69C585.937 1124.32 596.783 1117 606.408 1116.69L655.528 1133.72C656.568 1130.79 612.282 1116.87 607.809 1116.69C605.82 1111.36 600.579 1104.8 609.842 1103.04C614.271 1102.18 656.297 1112.71 662.352 1115.33V1115.29Z'
        fill='#F38F7E'
      />
      <path
        d='M418.196 1119.35C418.196 1119.35 417.654 1121.66 418.874 1122.07C425.607 1124.46 435.548 1125.41 442.734 1127.53C441.92 1128.26 431.979 1140.95 431.843 1141.86C430.126 1150.53 436.678 1177.29 442.734 1183.48C442.146 1183.66 440.022 1184.7 440.022 1184.83C440.339 1180.31 437.537 1182.66 435.232 1183.48C408.526 1192.65 358.23 1221.57 336.359 1192.33C322.215 1173.45 329.897 1160.39 332.247 1141.18H333.602C338.031 1144.71 344.222 1134.49 349.283 1131.65C370.748 1119.53 394.02 1116.82 418.151 1119.35H418.196Z'
        fill='#F38F7E'
      />
      <path
        d='M805.601 1096.17C806.188 1095.9 807.86 1096.44 808.312 1096.17C811.249 1109.91 815.452 1124.69 813.78 1138.47C794.936 1118.81 768.907 1115.38 742.833 1118C741.929 1115.15 740.935 1112.89 740.122 1109.82C745.499 1108.1 742.698 1104.71 742.833 1104.35C761.903 1104.17 788.113 1104.4 805.601 1096.17Z'
        fill='#D86660'
      />
      <path
        d='M419.552 1111.17L416.84 1116.64C399.352 1108.28 345.713 1123.38 333.648 1141.18H332.292C334.1 1126.49 335.139 1111.85 339.116 1097.53C343.183 1099.65 412.548 1111.17 419.597 1111.17H419.552Z'
        fill='#D86660'
      />
      <path
        d='M813.78 1138.47C813.599 1139.78 816.039 1139.96 813.78 1142.58C798.325 1121.75 766.603 1119.17 742.833 1120.75C742.743 1119.89 743.059 1118.67 742.833 1118.04C768.862 1115.42 794.936 1118.86 813.78 1138.51V1138.47Z'
        fill='black'
      />
      <path
        d='M670.531 1119.35C667.91 1117.91 665.063 1116.42 662.352 1115.24C661.041 1112.39 663.707 1110.04 663.707 1109.77L670.531 1119.31V1119.35Z'
        fill='#B86353'
      />
      <path
        d='M599.63 1133V1131.64C613.277 1139.01 637.091 1138.38 650.106 1150.04L599.63 1133Z'
        fill='#5D3934'
      />
      <path
        d='M606.453 1116.64C606.905 1116.64 607.357 1116.64 607.809 1116.64C612.282 1116.87 656.613 1130.79 655.528 1133.68L606.408 1116.64H606.453Z'
        fill='#311B1A'
      />
      <path
        d='M606.453 1152.12C606.317 1151.08 606.769 1150.63 607.809 1150.76C619.467 1156 639.079 1156.09 650.105 1166.44L606.453 1152.12Z'
        fill='#5D3934'
      />
      <path
        d='M416.84 1116.64C419.145 1117.73 417.97 1119.31 418.196 1119.35C394.02 1116.82 370.748 1119.53 349.328 1131.64C344.267 1134.49 338.076 1144.7 333.647 1141.18C345.713 1123.37 399.352 1108.28 416.84 1116.64Z'
        fill='#120504'
      />
      <path
        d='M517.792 1138.47C514.313 1140.5 465.554 1151.75 467.316 1156.86L519.148 1141.18C527.598 1148.23 517.521 1149.99 512.325 1156.18L468.672 1171.86L510.969 1158.89C507.128 1162.69 479.608 1180.4 472.106 1183.43C466.141 1185.83 463.294 1183.43 449.615 1183.43C446.678 1182.53 435.387 1187.88 427.388 1179.7C421.288 1173.51 430.216 1150.53 431.933 1141.81C432.114 1140.91 442.011 1128.21 442.824 1127.49C443.005 1127.31 446.168 1125.27 446.936 1124.78C452.585 1121.03 457.058 1119.94 463.295 1117.95C470.028 1115.78 505.411 1108.28 510.336 1109.77C519.826 1112.67 511.782 1118.9 512.37 1119.99C514.177 1123.29 535.642 1128.08 517.838 1138.38L517.792 1138.47Z'
        fill='#F38F7E'
      />
      <path
        d='M519.148 1141.18L467.317 1156.86C465.554 1151.75 514.313 1140.46 517.793 1138.47C517.973 1139.1 519.058 1141.09 519.148 1141.18Z'
        fill='#5D3934'
      />
      <path
        d='M512.325 1156.18C512.054 1156.5 511.15 1158.71 510.969 1158.89L468.672 1171.86L512.325 1156.18Z'
        fill='#4C2B20'
      />
      <path
        d='M507.535 1123.47C508.619 1123.33 511.782 1123.1 512.325 1124.14C496.915 1130.06 480.286 1133.5 464.605 1139.15C474.999 1132.82 495.695 1125.09 507.58 1123.47H507.535Z'
        fill='#382419'
      />
      <circle
        cx='685.489'
        cy='1000.08'
        r='26.3091'
        fill='#F69E23'
      />
      <circle
        cx='685.489'
        cy='1000.08'
        r='20.3297'
        fill='white'
      />
      <path
        d='M672.108 997.129C672.624 997.838 672.802 998.731 673.469 999.397C674.462 1000.39 675.894 996.253 676.631 995.73C677.923 994.816 680.086 997.645 681.634 997.532C683.996 997.36 686.175 996.675 688.564 996.675C689.892 996.675 691.123 996.222 692.407 996.222C693.08 996.222 693.748 995.995 694.448 995.995C695.365 995.995 696.726 996.885 697.51 997.356'
        stroke='black'
        strokeWidth='2.72163'
        strokeLinecap='round'
      />
      <path
        d='M680.046 1004.39C682.482 1004.39 684.918 1004.39 687.354 1004.39C687.868 1004.39 688.34 1004.42 688.828 1004.26C689.599 1004 690.357 1003.93 691.159 1003.93'
        stroke='black'
        strokeWidth='2.72163'
        strokeLinecap='round'
      />
      <g clipPath='url(#clip0_690_5218)'>
        <path
          d='M598.665 689.841C598.936 690.021 599.238 690.154 599.587 690.216L615.938 693.367C617.294 693.624 618.614 692.737 618.871 691.381C619.136 690.013 618.253 688.712 616.885 688.448L600.533 685.296C599.177 685.039 597.857 685.926 597.6 687.283C597.397 688.302 597.853 689.301 598.665 689.841Z'
          fill='#03141F'
        />
      </g>
      <g clipPath='url(#clip1_690_5218)'>
        <path
          d='M573.585 756.101C574.824 756.101 575.929 755.23 576.214 753.941C580.751 733.029 574.64 715.801 574.372 715.081C573.853 713.657 572.329 712.954 570.923 713.457C569.533 713.992 568.83 715.583 569.332 717.006C569.383 717.173 575.142 733.498 570.956 752.735C570.638 754.225 571.542 755.699 572.982 756.034C573.183 756.084 573.384 756.101 573.568 756.101H573.585Z'
          fill='black'
        />
        <path
          d='M548.94 691.758C548.605 691.942 548.22 692.059 547.818 692.11L528.162 694.052C526.538 694.202 525.098 693.014 524.914 691.39C524.746 689.749 525.935 688.309 527.576 688.141L547.232 686.183C548.856 686.015 550.313 687.221 550.48 688.845C550.597 690.067 549.961 691.189 548.94 691.741V691.758Z'
          fill='#03141F'
        />
        <path
          d='M602.583 726.818C600.892 726.751 599.67 725.428 599.737 723.854L600.39 708.317C600.457 706.743 601.495 705.454 603.353 705.605C604.927 705.672 606.15 706.994 606.083 708.568L605.43 724.106C605.363 725.629 604.107 726.835 602.583 726.835V726.818Z'
          fill='black'
        />
        <path
          d='M542.862 728.291C541.171 728.224 539.949 726.901 540.016 725.327L540.669 709.79C540.736 708.216 541.774 706.927 543.632 707.077C545.206 707.144 546.428 708.467 546.361 710.041L545.708 725.578C545.641 727.102 544.385 728.307 542.862 728.307V728.291Z'
          fill='black'
        />
        <path
          d='M556.557 775.188C558.348 776.294 563.84 779.357 572.295 779.91C582.391 780.58 589.607 777.198 591.332 776.327'
          stroke='black'
          strokeWidth='5.02286'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
      </g>
      <rect
        width='455.077'
        height='637.797'
        rx='42.7032'
        transform='matrix(-1 0 0 1 1263.5 224.007)'
        fill='#85A5FF'
      />
      <rect
        width='455.077'
        height='637.797'
        rx='42.7032'
        transform='matrix(-1 0 0 1 1225.57 194.703)'
        fill='white'
        stroke='#0B2777'
        strokeWidth='2.84688'
      />
      <rect
        x='980.004'
        y='728.21'
        width='162.096'
        height='40.524'
        rx='20.262'
        fill='#4760F6'
        stroke='black'
        strokeWidth='1.0131'
      />
      <path
        d='M244.498 1355.7L911.539 1355.7'
        stroke='#0B2777'
        strokeWidth='3.92362'
        strokeLinecap='round'
      />
      <path
        d='M933.167 1355.7H1126.68'
        stroke='#0B2777'
        strokeWidth='3.92362'
        strokeLinecap='round'
      />
      <rect
        x='827.511'
        y='297.716'
        width='140.974'
        height='39.9738'
        rx='8.9869'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='2.0262'
      />
      <rect
        x='990.511'
        y='297.716'
        width='140.974'
        height='39.9738'
        rx='8.9869'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='2.0262'
      />
      <rect
        x='827.511'
        y='369.716'
        width='303.974'
        height='39.9738'
        rx='8.9869'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='2.0262'
      />
      <rect
        x='827.511'
        y='441.716'
        width='303.974'
        height='39.9738'
        rx='8.9869'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='2.0262'
      />
      <rect
        x='827.511'
        y='562.716'
        width='303.974'
        height='39.9738'
        rx='8.9869'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='2.0262'
      />
      <rect
        x='827.511'
        y='501.716'
        width='50.9738'
        height='39.9738'
        rx='8.9869'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='2.0262'
      />
      <rect
        x='898.511'
        y='501.716'
        width='232.974'
        height='39.9738'
        rx='8.9869'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='2.0262'
      />
      <rect
        x='827.498'
        y='641.703'
        width='51.0176'
        height='51.0176'
        rx='6.36356'
        stroke='black'
        strokeWidth='2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M889.097 638.322C890.134 639.36 890.716 640.767 890.716 642.234C890.716 643.701 890.134 645.109 889.097 646.147L872.489 662.755L855.88 679.363C854.842 680.4 853.435 680.982 851.968 680.982C850.501 680.982 849.094 680.4 848.056 679.363L836.984 668.291C836.006 667.242 835.473 665.854 835.499 664.419C835.524 662.985 836.105 661.617 837.119 660.602C838.134 659.588 839.502 659.007 840.936 658.982C842.371 658.956 843.759 659.489 844.808 660.467L851.968 667.627L881.273 638.322C882.311 637.285 883.718 636.703 885.185 636.703C886.652 636.703 888.059 637.285 889.097 638.322Z'
        fill='black'
      />
      <rect
        x='911.498'
        y='641.703'
        width='51.0176'
        height='51.0176'
        rx='6.36356'
        stroke='black'
        strokeWidth='2'
      />
      <rect
        x='995.498'
        y='641.703'
        width='51.0176'
        height='51.0176'
        rx='6.36356'
        stroke='black'
        strokeWidth='2'
      />
      <rect
        x='1079.5'
        y='641.703'
        width='51.0176'
        height='51.0176'
        rx='6.36356'
        stroke='black'
        strokeWidth='2'
      />
      <path
        d='M1016.46 1104.27C1025.47 1104.27 1032.77 1096.96 1032.77 1087.95C1032.77 1078.94 1025.47 1071.64 1016.46 1071.64C1007.45 1071.64 1000.15 1078.94 1000.15 1087.95C1000.15 1096.96 1007.45 1104.27 1016.46 1104.27Z'
        fill='#BDBDBD'
      />
      <path
        d='M1014.28 1101.95C1022.02 1101.95 1028.28 1095.68 1028.28 1087.95C1028.28 1080.22 1022.02 1073.95 1014.28 1073.95C1006.55 1073.95 1000.28 1080.22 1000.28 1087.95C1000.28 1095.68 1006.55 1101.95 1014.28 1101.95Z'
        fill='#E0E0E0'
      />
      <path
        d='M1006.4 1083.06C1008.03 1080.61 1011.57 1078.57 1015.24 1078.03C1016.19 1077.89 1017 1077.89 1017.82 1078.16C1018.36 1078.44 1018.91 1078.98 1018.5 1079.52C1018.23 1080.07 1017.55 1080.2 1017 1080.34C1013.61 1081.29 1010.48 1083.6 1008.58 1086.32C1007.9 1087.41 1006.67 1090.26 1005.31 1089.58C1003.95 1088.63 1004.23 1086.05 1006.4 1083.06Z'
        fill='white'
      />
      <path
        d='M994.164 968.734C991.309 971.453 989.542 974.715 988.726 978.794C988.319 981.376 986.008 983.144 983.425 983.144H992.805C995.387 983.144 997.698 981.376 998.106 978.794C998.786 974.715 1000.69 971.453 1003.54 968.734C1006.4 966.151 1009.93 964.52 1014.15 963.84C1012.65 963.569 1011.02 963.433 1009.39 963.433C1003.14 963.569 998.106 965.336 994.164 968.734Z'
        fill='#BDBDBD'
      />
      <path
        d='M1053.16 952.287C1044.87 944.811 1033.45 941.141 1018.77 941.141C1017.14 941.141 1015.64 941.141 1014.15 941.277C1026.52 941.956 1036.44 945.627 1043.78 952.287C1052.07 959.764 1056.15 970.231 1056.15 983.553C1056.15 995.516 1050.58 1007.21 1039.57 1018.76L1026.25 1031.81L1025.84 1032.22C1021.9 1036.84 1019.58 1043.09 1018.77 1051.11C1018.5 1053.83 1016.19 1056.01 1013.33 1056.01H1022.71C1025.43 1056.01 1027.88 1053.83 1028.15 1051.11C1028.83 1043.09 1031.27 1036.84 1035.22 1032.22L1035.62 1031.81L1048.95 1018.76C1060.09 1007.21 1065.53 995.516 1065.53 983.553C1065.4 970.231 1061.32 959.764 1053.16 952.287Z'
        fill='#BDBDBD'
      />
      <path
        d='M1018.77 1051.25C1019.45 1043.23 1021.9 1036.98 1025.84 1032.35L1026.25 1031.95L1039.57 1018.9C1050.72 1007.34 1056.15 995.65 1056.15 983.688C1056.15 970.366 1052.07 959.899 1043.78 952.422C1036.44 945.761 1026.65 942.091 1014.15 941.411C1002.05 942.091 992.126 945.897 984.378 952.558C977.173 958.811 972.823 966.967 971.599 977.163C971.192 980.425 973.774 983.144 977.037 983.144H983.562C986.145 983.144 988.456 981.377 988.863 978.794C989.543 974.716 991.446 971.453 994.301 968.735C998.107 965.2 1003.27 963.433 1009.53 963.433C1011.16 963.433 1012.79 963.569 1014.28 963.841C1015.78 963.569 1017.27 963.433 1018.91 963.433C1025.43 963.433 1030.46 965.2 1033.86 968.871C1037.26 972.541 1039.02 977.706 1039.02 984.503C1039.02 989.669 1037.53 994.563 1034.67 998.913C1032.77 1001.9 1028.29 1006.8 1021.08 1013.73C1014.01 1020.66 1009.12 1027.05 1006.81 1032.76C1004.9 1037.38 1003.68 1043.23 1003.41 1050.3C1003.27 1053.42 1005.72 1056.01 1008.85 1056.01H1013.6C1016.05 1056.14 1018.5 1053.97 1018.77 1051.25Z'
        fill='#E0E0E0'
      />
      <path
        d='M985.33 957.315C989.952 951.606 998.788 947.528 1007.62 946.984C1009.8 946.848 1011.97 946.984 1013.74 947.936C1015.1 948.615 1016.05 950.111 1015.1 951.47C1014.28 952.558 1012.65 952.965 1011.29 953.237C1003 954.868 994.982 959.626 989.68 965.879C987.641 968.326 984.243 975.123 981.252 972.948C978.125 970.365 979.621 964.248 985.33 957.315Z'
        fill='white'
      />
      <path
        d='M1019.35 941.578C1036.45 941.578 1050.49 946.752 1058.89 956.142C1065.69 963.741 1068.46 973.727 1067.11 985.826C1066 995.782 1059.3 1002.31 1052.53 1008.14C1049.97 1010.35 1047.19 1012.25 1044.25 1014.27C1038.77 1018.03 1033.09 1021.92 1028.62 1028.03C1024.88 1033.14 1023.7 1039.76 1023.14 1047.28H1005.83C1006.45 1036.98 1007.89 1029.65 1011.83 1024.14C1014.65 1020.2 1019.2 1016.78 1024.02 1013.15C1028.1 1010.08 1032.32 1006.91 1035.75 1003.17C1045.21 992.884 1048.4 983.137 1044.98 974.983C1041.52 966.756 1032.23 962.037 1019.48 962.037C1017.63 962.037 1015.71 962.137 1013.79 962.344C1001.73 963.622 993.417 971.435 991.183 983.161H969.987C972.853 956.974 987.322 943.408 1014.08 941.744C1015.84 941.635 1017.62 941.578 1019.35 941.578ZM1019.35 936.141C1017.5 936.141 1015.63 936.2 1013.74 936.317C982.099 938.286 965.567 956.202 964.123 988.602H996.038C996.438 977.379 1002.7 968.989 1014.37 967.752C1016.06 967.57 1017.77 967.477 1019.48 967.474C1028.92 967.474 1037.17 970.443 1039.97 977.088C1043.52 985.543 1035.54 995.369 1031.75 999.493C1024.73 1007.14 1013.33 1012.72 1007.42 1020.97C1001.62 1029.06 1000.59 1039.7 1000.15 1052.72H1028.27C1028.67 1044.39 1029.22 1036.42 1033.01 1031.24C1039.17 1022.84 1048.37 1018.9 1056.08 1012.26C1063.45 1005.91 1071.2 998.264 1072.51 986.427C1076.24 952.981 1050.67 936.141 1019.35 936.141ZM1014.46 1069.72C1021.26 1069.72 1026.78 1075.13 1026.78 1081.78C1026.78 1088.43 1021.26 1093.83 1014.46 1093.83C1007.67 1093.83 1002.14 1088.42 1002.14 1081.78C1002.14 1075.13 1007.67 1069.72 1014.46 1069.72ZM1014.46 1064.29C1004.65 1064.29 996.702 1072.12 996.702 1081.78C996.702 1091.44 1004.65 1099.27 1014.46 1099.27C1024.27 1099.27 1032.22 1091.44 1032.22 1081.78C1032.22 1072.12 1024.27 1064.29 1014.46 1064.29Z'
        fill='black'
      />
      <defs>
        <clipPath id='clip0_690_5218'>
          <rect
            width='20.3774'
            height='11.4464'
            fill='white'
            transform='translate(602.921 678.925) rotate(33.6222)'
          />
        </clipPath>
        <clipPath id='clip1_690_5218'>
          <rect
            width='81.1862'
            height='96.3385'
            fill='white'
            transform='translate(524.913 686.183)'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
